import React from 'react';
import { FaLinkedin, FaEnvelope } from 'react-icons/fa';
import { FaGithub } from 'react-icons/fa'

function Social() {
  return (
    <>
      <div className="social">
        <a href='mailto:muhammadusamaaliu@gmail.com' target="_blank" rel='noreferrer'>
          <FaEnvelope />
        </a>
        <a href='https://www.linkedin.com/in/usama-ali-64201b261/' target='_blank' rel='noreferrer'>
          <FaLinkedin />
        </a>
        <a href='https://github.com/Osama-Ali-arch' target='_blank' rel='noreferrer'>
          <FaGithub />
        </a>
        <div className='bar'></div>
      </div>
    </>
  );
}

export default Social;
